import React from 'react';
import { useAuth } from '../context/AuthContext.js';
import AdminPanel from './AdminPanel.js';
import LoginPage from './LoginPage.js';
import './ProtectedAdmin.css';

const ProtectedAdmin = () => {
  const { isAuthenticated, user, loading, signOut } = useAuth();

  if (loading) {
    return <LoginPage />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <div className="protected-admin">
      <div className="admin-header-bar">
        <div className="admin-user-info">
          <img 
            src={user.picture} 
            alt={user.name}
            className="user-avatar"
          />
          <div className="user-details">
            <span className="user-name">{user.name}</span>
            <span className="user-email">{user.email}</span>
          </div>
        </div>
        <div className="admin-actions">
          <a 
            href="/"
            className="back-to-site-button"
            title="Back to main site"
          >
            <i className="fas fa-home"></i>
            Back to Site
          </a>
          <button 
            onClick={signOut}
            className="sign-out-button"
            title="Sign out"
          >
            <i className="fas fa-sign-out-alt"></i>
            Sign Out
          </button>
        </div>
      </div>
      <AdminPanel />
    </div>
  );
};

export default ProtectedAdmin;
